/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { pushOneNews } from "../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  Modal,
  GoBack,
  MySearch,
  MyButton,
  Pagination,
  DashboardIntro,
} from "../../home/component/Component";
import { _TYPES_ } from "../utils/types";
import { _PAGE_SIZE_ } from "../../../middlewares/other/tools";
import { useGeoPositionContext } from "../utils/geoPosition";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import PromoteContent from "../utils/PromoteContent";
import { FaRegCheckSquare, FaRegSquare, FaRegTrashAlt } from "react-icons/fa";
import { RiRefreshLine } from "react-icons/ri";

const addRoute = "/data/news/add";
const editRoute = "/data/news/edit";
const doseeDataRoutes = "/dosee/data";

const Overview = () => {
  const [newsList, setNewsList] = useState([]);
  const { news, newsCount, fetchDoSeeData, deleteOneContent } =
    useDoSeeDataContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);
  const [localSearch, setLocalSearch] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedContentIds, setSelectedContentIds] = useState([]); // store as strings

  const {
    country_id,
    entry_label,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const data_request_body = {
    country_id,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    content: _TYPES_.NEWS,
  };

  useEffect(() => {
    if (!news) fetchDoSeeData(data_request_body, page, pageSize);
    else setNewsList(news);
  }, [news]);

  const reloadData = () => fetchDoSeeData(data_request_body, page, pageSize);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    news.map((nws) => {
      if (nws?.title.toString().toLowerCase().includes(key))
        return searchArray.push(nws);
      return true;
    });
    setNewsList(searchArray);
    if (key === "") setNewsList(news);
  };

  const LocalData = localSearch?.length > 0 ? localSearch : newsList;

  const deleteMany = async () => {
    setLoading(true);
    for (let i = 0; i < selectedContentIds.length; i++) {
      await deleteOneContent({
        data_id: selectedContentIds[i],
        content: _TYPES_.NEWS,
      });
    }
    setLoading(false);
    reloadData();
  };

  // ---------- Selection helpers (fix) ----------
  const idOf = (item) => String(item?.news_id ?? "");
  const selectedSet = useMemo(
    () => new Set(selectedContentIds.map((x) => String(x))),
    [selectedContentIds]
  );

  const pageIds = useMemo(
    () => LocalData.map(idOf).filter(Boolean),
    [LocalData]
  );

  const masterSelected = useMemo(
    () => pageIds.length > 0 && pageIds.every((id) => selectedSet.has(id)),
    [pageIds, selectedSet]
  );

  const toggleRow = (row) => {
    const id = idOf(row);
    if (!id) return;
    if (selectedSet.has(id)) {
      setSelectedContentIds((prev) => prev.filter((v) => String(v) !== id));
    } else {
      setSelectedContentIds((prev) => [...prev, id]);
    }
  };

  const toggleAllOnPage = () => {
    if (masterSelected) {
      // unselect only the items from the current page
      setSelectedContentIds((prev) =>
        prev.filter((id) => !pageIds.includes(String(id)))
      );
    } else {
      // add current page items (avoid duplicates)
      setSelectedContentIds((prev) => Array.from(new Set([...prev, ...pageIds])));
    }
  };
  // --------------------------------------------

  // compact design tokens
  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card = "rounded-xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-3 sm:p-4";
  const btnBase =
    "inline-flex items-center gap-2 px-3.5 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";

  return (
    <div className="h-full overflow-y-auto bg-slate-50">
      <div className={`${container} py-4 lg:py-6`}>
        <div className="mb-3">
          <BreadCrumbComponent />
        </div>

        <div className="flex items-center justify-between mb-2">
          <GoBack props={{ route: doseeDataRoutes }} />
        </div>

        <div className="mb-4">
          <DashboardIntro props={{ intro: `News`, name: entry_label }} />
        </div>

        <div className="space-y-4">
          <div className={`${card} ${sectionPad}`}>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
              <MySearch
                type={_TYPES_.NEWS}
                value={localSearch}
                showGlobalSearch={true}
                setValue={setLocalSearch}
                onChange={(e) => SearchList(e)}
              />
              {country_id ? (
                <Link to={addRoute} className="shrink-0">
                  <MyButton
                    title="Add News"
                    className={`${btnBase} ${btnPrimary}`}
                    onClick={() => { }}
                  />
                </Link>
              ) : null}
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <div className="flex flex-wrap items-center gap-3">
              <MyButton
                className={`${btnBase} ${btnNeutral}`}
                onClick={toggleAllOnPage}
              >
                {masterSelected ? (
                  <FaRegCheckSquare className="text-green-600 text-lg" />
                ) : (
                  <FaRegSquare className="text-slate-700 text-lg" />
                )}
                <span className="text-slate-700">
                  {masterSelected ? "Unselect All" : "Select All"}
                </span>
              </MyButton>

              <MyButton
                onClick={deleteMany}
                className={`${btnBase} ${selectedContentIds?.length > 0 ? btnDanger : btnNeutral
                  }`}
                disabled={selectedContentIds?.length === 0 || loading}
              >
                {loading ? (
                  <RiRefreshLine className="text-lg animate-spin" />
                ) : (
                  <FaRegTrashAlt className="text-base" />
                )}
                <span>
                  Delete{" "}
                  {selectedContentIds?.length > 0
                    ? selectedContentIds.length
                    : ""}{" "}
                  {selectedContentIds?.length === 1 ? "Item" : "Items"}
                </span>
              </MyButton>
            </div>

            <div className="mt-4 overflow-x-auto rounded-lg border border-slate-200">
              <table className="w-full text-sm">
                <thead className="bg-slate-50 text-slate-600 sticky top-0 z-10">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold w-[120px]">
                      Select
                    </th>
                    <th className="px-4 py-3 text-left font-semibold w-1/2">
                      Title
                    </th>
                    <th className="px-4 py-3 text-left font-semibold w-1/4">
                      Published On
                    </th>
                    <th className="px-4 py-3 text-center font-semibold w-[220px]">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200">
                  {news || LocalData ? (
                    LocalData?.map((nws, key) => {
                      const id = idOf(nws);
                      const isSelected = selectedSet.has(id);
                      return (
                        <tr
                          key={key}
                          className="hover:bg-slate-50 transition-colors"
                        >
                          <td className="px-4 py-3">
                            <MyButton
                              className={`${btnBase} ${btnNeutral}`}
                              onClick={() => toggleRow(nws)}
                            >
                              {isSelected ? (
                                <FaRegCheckSquare className="text-green-600 text-lg" />
                              ) : (
                                <FaRegSquare className="text-slate-700 text-lg" />
                              )}
                            </MyButton>
                          </td>
                          <td className="px-4 py-3">{nws?.title}</td>
                          <td className="px-4 py-3">{nws?.published_on}</td>
                          <td className="px-2 py-3">
                            <ActionButton props={nws} reloadData={reloadData} />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="animate-pulse">
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                      <td className="px-4 py-3">...</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className={`${card} ${sectionPad}`}>
            <Pagination
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              total_items={newsCount}
              callbackFunction={(p, size) => {
                fetchDoSeeData(data_request_body, p, size);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props, reloadData }) => {
  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);
  const { news, deleteOneContent, updateOneContent } = useDoSeeDataContext();

  const [showModal, setShowModal] = useState(false);
  const [promote, setPromote] = useState(false);
  const [promoteLoader, setPromoteLoader] = useState(false);

  const news_id = props.news_id;
  const news_title = props.title;
  const nws = props;

  const deleteOneById = async (news_id) => {
    const { status } = await deleteOneContent({
      data_id: news_id,
      content: _TYPES_.NEWS,
    });
    if (status === 200) {
      reloadData();
    }
  };

  const buildData = (object, position) => {
    return {
      promoted: `${position}`,
      country_id: object?.country_id,
      description: object?.description,
      first_level_id: object?.first_level_id,
      fourth_level_id: object?.fourth_level_id,
      second_level_id: object?.second_level_id,
      slug: object?.slug,
      status: object?.status,
      third_level_id: object?.third_level_id,
      thumbnail: object?.thumbnail,
      title: object?.title,
    };
  };

  const promotion = async (position) => {
    const previousPromoted = news?.find(
      (news) => news?.promoted === String(position)
    );

    setPromoteLoader(true);

    const { status } = await updateOneContent({
      data_id: nws?.news_id,
      data: buildData(props, position),
      content: _TYPES_.NEWS,
    });

    if (previousPromoted) {
      await updateOneContent({
        data_id: previousPromoted?.news_id,
        data: buildData(previousPromoted, "no"),
        content: _TYPES_.NEWS,
      });
    }

    if (status === 200) {
      reloadData();
    }
  };

  const suspension = async (nws) => {
    const data = {
      country_id: nws?.country_id,
      description: nws?.description,
      first_level_id: nws?.first_level_id,
      fourth_level_id: nws?.fourth_level_id,
      second_level_id: nws?.second_level_id,
      slug: nws?.slug,
      status: nws?.status === 1 ? 0 : 1,
      third_level_id: nws?.third_level_id,
      thumbnail: nws?.thumbnail,
      title: nws?.title,
    };

    const { status } = await updateOneContent({
      data_id: nws?.news_id,
      data: data,
      content: _TYPES_.NEWS,
    });

    if (status === 200) {
      reloadData();
    }
  };

  const btnBase =
    "inline-flex items-center gap-2 px-3 py-2 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 text-xs";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";
  const btnInfo =
    "bg-blue-700 text-white border-blue-700 hover:bg-blue-600 focus-visible:ring-blue-600";
  const btnWarn =
    "bg-amber-600 text-white border-amber-600 hover:bg-amber-500 focus-visible:ring-amber-500";
  const btnDanger =
    "bg-red-600 text-white border-red-600 hover:bg-red-500 focus-visible:ring-red-500";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500";

  return (
    <>
      <Modal
        props={{
          name: news_title,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneById(news_id),
        }}
      />

      <PromoteContent
        visible={promote}
        setVisible={setPromote}
        loading={promoteLoader}
        ids={news
          ?.filter(
            (news) => !["yes", "no", null, undefined].includes(news?.promoted)
          )
          .map((news) => ({
            id: news?.news_id,
            title: news?.title,
            position: parseInt(news?.promoted),
          }))}
        onClick={(position) => promotion(position)}
      />

      <div className="flex flex-row justify-end items-center px-2 py-2 gap-2">
        {isSuperAdmin ? (
          <>
            <MyButton
              title={nws?.status === 1 ? "Suspend" : "Unsuspend"}
              className={`${btnBase} ${nws?.status === 1 ? btnPrimary : btnWarn}`}
              onClick={() => suspension(nws)}
            />
            <MyButton
              title={
                ["yes", "no", null, undefined].includes(nws?.promoted)
                  ? "Promote"
                  : "Unpromote"
              }
              className={`${btnBase} ${["yes", "no", null, undefined].includes(nws?.promoted)
                ? btnNeutral
                : btnWarn
                }`}
              onClick={() => setPromote(true)}
            />
          </>
        ) : null}

        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className={`${btnBase} ${btnInfo}`}
            onClick={() => pushOneNews(nws)}
          />
        </Link>
        <MyButton
          title="Delete"
          className={`${btnBase} ${btnDanger}`}
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
